/* global chrome */

const loadScript = (url) => new Promise((resolve, reject) => {
  const src = document.createElement('script');
  src.setAttribute('type', 'text/javascript');
  src.setAttribute('src', url);

  if (src.readyState) {
    src.onreadystatechange = () => {
      if (src.readyState === 'complete' || src.readyState === 'loaded') {
        src.onreadystatechange = null;
        resolve();
      }
    };
  } else {
    src.onload = () => {
      resolve();
    };
  }

  const htmlHead = document.getElementsByTagName('head')[0];
  htmlHead.insertBefore(src, htmlHead.firstChild);
});

// Run script
// Setup chromecast
const castSenderManager = {
  setup() {
    return new Promise((resolve, reject) => {
      window['__onGCastApiAvailable'] = (isAvailable) => {
        if (isAvailable) {
          castSenderManager.initializeCastApi(window.cast);
          resolve(window.cast);
        } else {
          reject(new Error('Chromecast is not supported here'));
        }
      };

      if (!('cast' in window)) {
        loadScript('https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1');
      }
    });
  },

  initializeCastApi() {
    const castInstance = window.cast.framework.CastContext.getInstance();

    castInstance.setOptions({
      receiverApplicationId: chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
      autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
    });

    castInstance.addEventListener(
      window.cast.framework.CastContextEventType.SESSION_STATE_CHANGED,
      (event) => {
        if (event.sessionState === window.cast.framework.SessionState.SESSION_STARTED) {
          castSenderManager.playQueuedMedia();
        }
      },
    );
  },
  loadMedia({ mediaUrl, mediaType, meta }) {
    const castSession = window.cast.framework.CastContext.getInstance().getCurrentSession();

    const mediaInfo = new chrome.cast.media.MediaInfo(mediaUrl, mediaType);
    mediaInfo.metadata = new chrome.cast.media.GenericMediaMetadata();
    mediaInfo.metadata.title = meta.title;
    mediaInfo.metadata.subtitle = meta.subtitle;
    mediaInfo.metadata.images = new chrome.cast.Image(meta.image);

    const request = new chrome.cast.media.LoadRequest(mediaInfo);
    return castSession.loadMedia(request);
    // const player = new cast.framework.RemotePlayer();
    // const playerController = new cast.framework.RemotePlayerController(player);
  },

  queuedMedia: {
  },

  queueMedia(media) {
    castSenderManager.queuedMedia = media;
  },

  playQueuedMedia() {
    castSenderManager.loadMedia(castSenderManager.queuedMedia);
  },
};

export default castSenderManager;
